<template>
  <div>

    <Loader cover v-if="local.isProcessing"/>
    <CommonFilterForTable :parentState="state" @load-data="loadData"/>
    <ListTable/>

  </div>
</template>

<script>
import {state, loadData} from './data';
import AdvisorOnlineSchedule from '@/store/modules/advisor-online-schedule/index';
import {createNamespacedHelpers} from "vuex";

if (!state.store.AdvisorOnlineSchedule) state.registerModule(`AdvisorOnlineSchedule`, AdvisorOnlineSchedule);

const {
  mapActions: mapAdvisorOnlineScheduleActions,
} = createNamespacedHelpers(`AdvisorOnlineSchedule`);

export default {
  components: {
    Loader: () => import('@/components/common-ui/loader-block/index.vue'),
    CommonFilterForTable: () => import('@/components/shared/filters/CommonFilterForTable.vue'),
    ListTable: () => import('./SubComponents/AdvisorOnlineScheduleList.vue'),
  },
  data() {
    return {
      state: state,
      local: state.local,
    }
  },
  methods: {
    //---------------------------------------- State Function ------------------------------------------------------//
    ...mapAdvisorOnlineScheduleActions({
      getAdvisorOnlineSchedulesByFilterForTable: 'getAdvisorOnlineSchedulesByFilterForTable',
    }),
    async loadData() {
      let func = {getAdvisorOnlineSchedulesByFilterForTable: this.getAdvisorOnlineSchedulesByFilterForTable};
      await loadData(func);
    }
  },
}
</script>
